const isOnline = () => window.navigator.onLine;

export default isOnline;
